module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/signs-of-seperated-instrument.88b48cee.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/signs-of-seperated-instrument.png
// module id = 303
// module chunks = 0